import { Header } from "./layout/Header";
import { Footer } from "./layout/Footer";
import { MainContent } from "./layout/MainContent";

function App() {
  return (
    <>
      <Header />
      <MainContent />
      <Footer />
    </>
  );
}

export default App;
